import { render, staticRenderFns } from "./AssetReviews.vue?vue&type=template&id=559c013b"
import script from "./AssetReviews.vue?vue&type=script&lang=js"
export * from "./AssetReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports